/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Cards_BodyInputs */



/**
* | output |
* | --- |
* | "Built-in looks on every plan, and a card editor with your own images on paid ones." |
*
* @param {Features_Cards_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_cards_body = /** @type {((inputs?: Features_Cards_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Cards_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроенные оформления на любом тарифе, а на платных — редактор карточек со своими изображениями.")
	return /** @type {LocalizedString} */ ("Built-in looks on every plan, and a card editor with your own images on paid ones.")
});